module.exports = "<div class=\"footer\">\r\n    <div class=\"text-center\">\r\n        <strong>© GoRent - 2019</strong> todos los derechos reservados.\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/padriana/gorent-panel/src/app/dashboard/layout/footer/footer.component.html
// module id = ../../../../../src/app/dashboard/layout/footer/footer.component.html
// module chunks = main